(function(){
'use strict';

scSocialButtons.$inject = ["$compile", "$parse", "$templateCache", "$location", "$timeout", "$http", "$window", "linkBigTip", "scSocialShareLinks", "scPagesService", "scSingleShareService", "scDomainsService", "$state", "accessibilityService"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @kind directive
 * @name scSocialButtons
 *
 * @description
 * Outputs social share buttons
 */

function scSocialButtons($compile, $parse, $templateCache, $location, $timeout, $http, $window, linkBigTip, scSocialShareLinks, scPagesService, scSingleShareService, scDomainsService, $state, accessibilityService) {
  return {
    scope: {},

    link: function link(scope, element, attrs) {
      scope.twitterUrl = '';
      scope.mailToUrl = '';
      scope.smsUrl = '';
      scope.instagramUrl = '';

      var showQRModeTimeout = void 0;

      scope.instagramDataId = $location.url().includes('thank') && 'thankyou-share-meta_ig';

      scope.cta = $parse(attrs.callToAction)(scope);
      scope.mode = $parse(attrs.scSocialButtons)(scope);
      var isUnifiedShare = attrs.isUnifiedShare || false;

      scope.isMobile = window.matchMedia('(max-width: 768px)').matches;

      scope.modeClass = function () {
        return scope.mode + '-mode';
      };

      var template = $templateCache.get('global/directives/scSocialButtons/template');

      if (isUnifiedShare === 'true') {
        template = $templateCache.get('global/directives/scSocialButtons/share.template');
        scope.copyText = 'Copy link';
        scope.npoLogo = SC.organization.branding.header_image;
        scope.campaignName = SC.campaign.name;
      }

      var compiled = null;

      switch (scope.mode) {
        case 'tooltip':
          {
            var tooltip = linkBigTip({
              element: element,
              template: template,
              scope: scope,
              event: 'click',
              width: 140,
              scroll: false,
              bg: '#F8F8F8'
            });
            scope.open = tooltip.open;
            scope.close = tooltip.close;
            break;
          }

        case 'overlay':
          {
            scope.open = function () {
              if (scSingleShareService.isOn() != true) {
                compiled = $compile(template)(scope);
                compiled.appendTo('body').attr('tabindex', '0');

                if (!isUnifiedShare) {
                  compiled.focus();
                }

                scSingleShareService.On();

                // Unified, more prominent Share icon across all FRS pages
                if (isUnifiedShare === 'true') {
                  scope.isQrMode = false;
                  var entity = scope.getEntityType(SC);

                  scDomainsService.getSlug(entity.type, entity.id).then(function (response) {
                    if (response.data.total > 0) {
                      var domainMaskURL = response.data.data[0].domain_masking_url;
                      var slug = response.data.data[0].value;
                      scope.vanityURL = domainMaskURL + '/' + slug;
                    } else {
                      scope.vanityURL = window.location.href;
                    }
                  });
                }

                if ($state.is('frs.fundraiser.index')) {
                  var modalElements = document.querySelector('#social-dropdown-menu');
                  modalElements.addEventListener(accessibilityService.CONSTANTS.KEYDOWN_EVENT, scope.handleKeyEvents(modalElements));
                }
                document.querySelector('.public-page').setAttribute('aria-hidden', 'true');
              }
            };
            scope.close = function () {
              scSingleShareService.Off();
              scope.isQrMode = false;
              document.querySelector('.public-page').removeAttribute('aria-hidden');
              element.focus();
              if (compiled) {
                compiled.remove();
              }
            };
            element.on('click', scope.open);
            scope.$on('scSocialButtons.open', scope.open);
            scope.$on('$destroy', function () {
              element.off('click', scope.open);
            });
            break;
          }

        case 'icons':
          compiled = $compile(template)(scope);
          compiled.appendTo(element);
          break;

        default:
        // do nothing
      }

      /* -------------------------------------------------------------------- *
       * Init
       * -------------------------------------------------------------------- */

      scope.previousUrl = scPagesService.getShareableUrl();

      scSocialShareLinks.getSocialData().then(function (data) {
        scope.twitterUrl = data.twitter_link;
        scope.mailToUrl = data.email_link;
        scope.smsUrl = data.sms_link;
        scope.fbShare = data.facebook_share;
        scSocialShareLinks.getInstagramLink().then(function (additionalData) {
          var combinedData = Object.assign({}, data, additionalData);

          scope.twitterUrl = combinedData.twitter_link;
          scope.mailToUrl = combinedData.email_link;
          scope.smsUrl = combinedData.sms_link;
          scope.fbShare = combinedData.facebook_share;
          scope.instagramUrl = combinedData.instagram_link;
        });
      });

      scope.getEntityType = function (SC) {
        if (SC.fundraiser) {
          scope.name = SC.fundraiser.name;
          return { type: 'fundraising-pages', id: SC.fundraiser.id, name: SC.fundraiser.name };
        } else if (SC.team) {
          scope.name = SC.team.name;
          return { type: 'fundraising-teams', id: SC.team.id, name: SC.team.name };
        } else if (SC.campaign) {
          scope.name = SC.campaign.name;
          return { type: 'campaigns', id: SC.campaign.id, name: SC.campaign.name };
        }
        return { type: 'campaigns', id: SC.campaign.id, name: SC.campaign.name };
      };

      scope.isPreview = function () {
        if ($state.is('admin.manage.campaign.step.setup') || $state.is('admin.manage.campaign.step.design.views.content-blocks')) {
          return true;
        }
        return false;
      };

      scope.setCancelButton = function ($event) {
        if ($event) {
          if ($event.keyCode === accessibilityService.CONSTANTS.ENTER_KEY || $event.keyCode === accessibilityService.CONSTANTS.SPACE_KEY) {
            this.close();
          }
        }
      };

      scope.handleKeyEvents = function (modalElements) {
        return function (event) {
          /**
          getting all the focusable elements in the modal.
          get the first and last focusable element in the modal
          */
          var focusableModalElements = modalElements.querySelectorAll(accessibilityService.CONSTANTS.ELEMENTS_TO_FOCUS);
          var firstFocusableElement = focusableModalElements[0];
          var lastFocusableElement = focusableModalElements[focusableModalElements.length - 1];
          function handleBackwardTab() {
            if (document.activeElement === firstFocusableElement) {
              event.preventDefault();
              lastFocusableElement.focus();
            }
          }
          function handleForwardTab() {
            if (document.activeElement === lastFocusableElement) {
              event.preventDefault();
              firstFocusableElement.focus();
            }
          }

          switch (event.keyCode) {
            case accessibilityService.CONSTANTS.TAB_KEY:
              // If there is only one focusable element in the modal, there is no need to handle tabbing events
              if (focusableModalElements.length === 1) {
                event.preventDefault();
                break;
              }
              if (event.shiftKey) {
                handleBackwardTab();
              } else {
                handleForwardTab();
              }
              break;
            case accessibilityService.CONSTANTS.ESC_KEY:
              scope.close();
              element.focus();
              break;
            default:
              break;
          }
        };
      };

      // Generate QR Code as Data URL
      scope.generateQrCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var qrUrl, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                qrUrl = scope.vanityURL || $location.absUrl();
                _context.next = 3;
                return $http({
                  method: 'GET',
                  url: '/frs-api/generate/qr-code',
                  params: {
                    url: qrUrl
                  }
                });

              case 3:
                result = _context.sent;


                scope.qrCodeUrl = result.data.url || null;
                scope.$apply();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      scope.saveQr = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var canvas, ctx, imagesLoaded, totalImages, loadedLogoImage, loadedQrImage, drawCompleteImage, logoImage, qrImage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                drawCompleteImage = function drawCompleteImage() {
                  if (imagesLoaded !== totalImages) return;

                  // Clear canvas and redraw background
                  ctx.fillStyle = '#ffffff';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);

                  // Add border
                  ctx.strokeStyle = '#000000';
                  ctx.lineWidth = 2;
                  ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);

                  // Draw logo at the top
                  if (loadedLogoImage) {
                    // Calculate logo dimensions and position
                    var maxLogoWidth = 300;
                    var maxLogoHeight = 60;

                    var logoWidth = loadedLogoImage.width;
                    var logoHeight = loadedLogoImage.height;

                    // Scale logo to fit within max dimensions while maintaining aspect ratio
                    var widthRatio = maxLogoWidth / logoWidth;
                    var heightRatio = maxLogoHeight / logoHeight;
                    var scale = Math.min(widthRatio, heightRatio, 1);

                    logoWidth *= scale;
                    logoHeight *= scale;

                    // Center the logo horizontally at the top
                    var logoX = (canvas.width - logoWidth) / 2;
                    var logoY = 20;

                    ctx.drawImage(loadedLogoImage, logoX, logoY, logoWidth, logoHeight);
                  }

                  // Draw QR code in the middle
                  if (loadedQrImage) {
                    var qrSize = 200;
                    var qrX = (canvas.width - qrSize) / 2;
                    var qrY = 100; // Positioned below logo

                    ctx.drawImage(loadedQrImage, qrX, qrY, qrSize, qrSize);

                    // Add text below QR code
                    ctx.fillStyle = '#000000';
                    ctx.font = '16px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText('Scan to support', canvas.width / 2, qrY + qrSize + 30);

                    // Add organization name
                    ctx.font = 'bold 18px Arial';
                    var entity = scope.getEntityType(SC);
                    ctx.fillText(entity.name, canvas.width / 2, qrY + qrSize + 60);
                  }

                  // Download the complete image
                  canvas.toBlob(function (blob) {
                    var url = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'qr-code.png';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                  }, 'image/png');
                };

                // Create canvas element
                canvas = document.createElement('canvas');
                ctx = canvas.getContext('2d');

                // Set canvas dimensions

                canvas.width = 400;
                canvas.height = 500;

                // Fill background with white
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // Add border
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 2;
                ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);

                // Counter to track when both images are loaded
                imagesLoaded = 0;
                totalImages = 2;

                // Variables to store loaded images

                loadedLogoImage = null;
                loadedQrImage = null;


                // Load logo image
                logoImage = new Image();

                logoImage.crossOrigin = 'anonymous';

                logoImage.onload = function () {
                  loadedLogoImage = this;
                  // eslint-disable-next-line no-plusplus
                  imagesLoaded++;
                  drawCompleteImage();
                };

                logoImage.onerror = function () {
                  // eslint-disable-next-line no-console
                  console.warn('Logo failed to load, continuing without logo');
                  // eslint-disable-next-line no-plusplus
                  imagesLoaded++;
                  drawCompleteImage();
                };

                // Load QR code image
                qrImage = new Image();

                qrImage.crossOrigin = 'anonymous';

                qrImage.onload = function () {
                  loadedQrImage = this;
                  // eslint-disable-next-line no-plusplus
                  imagesLoaded++;
                  drawCompleteImage();
                };

                qrImage.onerror = function () {
                  // eslint-disable-next-line no-console
                  console.error('QR code failed to load');
                  // eslint-disable-next-line no-plusplus
                  imagesLoaded++;
                  drawCompleteImage();
                };

                // Start loading both images
                logoImage.src = scope.npoLogo;
                qrImage.src = scope.qrCodeUrl;

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      scope.getRoute = function () {
        if ($state.includes('frs.fundraiser.index')) {
          return 'frs.fundraiser.index.printposter';
        }

        if ($state.includes('frs.landing.name.campaign')) {
          return 'frs.landing.name.campaign.printposter';
        }

        if ($state.includes('frs.fundraiser.dashboardindex')) {
          return 'frs.fundraiser.dashboardindex.printposter';
        }

        if ($state.includes('frs.team.index')) {
          return 'frs.team.index.printposter';
        }

        if ($state.includes('frs.team.dashboardindex')) {
          return 'frs.team.dashboardindex.printposter';
        }

        return null;
      };

      scope.openPrintPoster = function () {
        var stateParams = {
          vanityURL: scope.vanityURL || null
        };

        window.localStorage.setItem('qrCodeUrl', scope.qrCodeUrl);

        var route = scope.getRoute();

        var baseUrl = $state.href(route, stateParams);

        $window.open(baseUrl, '_blank');

        scope.close();
      };

      /* QR Mode Functions */
      scope.showQrMode = function () {
        if (showQRModeTimeout) {
          $timeout.cancel(showQRModeTimeout);
        }

        scope.generateQrCode();

        var socialIconContent = compiled.find('.social-icon-content');
        socialIconContent.removeClass('slide-in').addClass('slide-out');

        scope.isQrMode = true;
        showQRModeTimeout = $timeout(function () {
          var qrSection = compiled.find('.qr-content');
          qrSection.removeClass('slide-out').addClass('slide-in');
          compiled.find('.social-buttons_section').addClass('qr-code-mode');
        }, 50);
      };

      scope.onCopySuccess = function () {
        scope.copyText = 'Copied';
        $timeout(function () {
          scope.copyText = 'Copy link';
        }, 3000);
      };

      scope.goBack = function () {
        var qrSection = compiled.find('.qr-content');
        qrSection.removeClass('slide-in').addClass('slide-out');
        compiled.find('.social-buttons_section').removeClass('qr-code-mode');
        var socialIconContent = compiled.find('.social-icon-content');
        socialIconContent.removeClass('slide-out').addClass('slide-in');
      };
    }
  };
}

angular.module('classy').directive('scSocialButtons', scSocialButtons);
})();